import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "container mx-auto px-6 md:px-12 max-w-7xl flex items-center justify-between" };
const _hoisted_2 = {
    href: "#",
    class: "flex items-center gap-2 group"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "flex items-center gap-8" };
const _hoisted_5 = { class: "hidden md:flex items-center gap-8" };
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "hidden md:flex items-center gap-2 font-mono text-xs uppercase font-bold" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 0,
    class: "opacity-20"
};
const _hoisted_10 = {
    key: 0,
    class: "fixed inset-0 z-50 pt-6 px-6 bg-offWhite dark:bg-darkBg md:hidden flex flex-col"
};
const _hoisted_11 = { class: "flex items-center justify-between mb-12" };
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = { class: "flex flex-col gap-6 flex-grow" };
const _hoisted_14 = ["href"];
const _hoisted_15 = { class: "py-8 border-t border-black/10 dark:border-white/10" };
const _hoisted_16 = { class: "flex items-center gap-4 font-mono text-sm uppercase font-bold" };
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
    key: 0,
    class: "opacity-20"
};
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { Icon } from "@iconify/vue";
import { PORTFOLIO_OWNER, CONTENT } from "../constants";
import { useLanguage } from "../composables/useLanguage";
import logoDark from "../mjs_d_t.png"; // light-toned mark, for dark backgrounds
import logoLight from "../mjs_t.png"; // dark-toned mark, for light backgrounds
export default /*@__PURE__*/ _defineComponent({
    __name: 'Header',
    props: {
        darkMode: { type: Boolean }
    },
    emits: ["toggleTheme"],
    setup(__props) {
        const isScrolled = ref(false);
        const mobileMenuOpen = ref(false);
        const { language, setLanguage } = useLanguage();
        const handleScroll = () => {
            isScrolled.value = window.scrollY > 50;
        };
        onMounted(() => {
            window.addEventListener("scroll", handleScroll);
        });
        onUnmounted(() => {
            window.removeEventListener("scroll", handleScroll);
        });
        // Close mobile menu on resize to desktop
        watch(mobileMenuOpen, (isOpen) => {
            if (isOpen) {
                document.body.style.overflow = "hidden";
            }
            else {
                document.body.style.overflow = "";
            }
        });
        const text = computed(() => CONTENT[language.value]);
        const navLinks = computed(() => [
            { name: text.value.nav.services, href: "#services" },
            { name: text.value.nav.skills, href: "#skills" },
            { name: text.value.nav.work, href: "#projects" },
            { name: text.value.nav.about, href: "#about" },
        ]);
        const languages = ["en", "cz", "de"];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("header", {
                    class: _normalizeClass([
                        'fixed top-0 left-0 right-0 z-40 w-full transition-all duration-500 border-b',
                        isScrolled.value
                            ? 'bg-offWhite/80 dark:bg-darkBg/80 backdrop-blur-lg py-4 border-black/5 dark:border-white/5'
                            : 'bg-transparent py-6 border-transparent',
                    ])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("a", _hoisted_2, [
                            _createElementVNode("img", {
                                src: __props.darkMode ? _unref(logoDark) : _unref(logoLight),
                                alt: `${_unref(PORTFOLIO_OWNER)} logo`,
                                class: "w-11 h-11 object-contain group-hover:scale-105 transition-transform duration-300"
                            }, null, 8 /* PROPS */, _hoisted_3),
                            _cache[6] || (_cache[6] = _createStaticVNode("<span class=\"font-bold tracking-tight text-lg uppercase hidden md:block leading-[0.85]\"><span class=\"block\"><span class=\"text-[#101a12] dark:text-[#d1ebd6]\">Martin</span> <span class=\"text-[#56775f]\">J.</span></span><span class=\"block text-[#94af9b]\">Skalicky</span></span>", 1))
                        ]),
                        _createElementVNode("nav", _hoisted_4, [
                            _createCommentVNode(" Desktop Navigation "),
                            _createElementVNode("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navLinks.value, (link) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                        key: link.href,
                                        href: link.href,
                                        class: "text-sm font-medium uppercase tracking-wider opacity-60 hover:opacity-100 hover:text-accent transition-all duration-300"
                                    }, _toDisplayString(link.name), 9 /* TEXT, PROPS */, _hoisted_6));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-[1px] h-6 bg-black/10 dark:bg-white/10 hidden md:block" }, null, -1 /* CACHED */)),
                            _createCommentVNode(" Language Switcher "),
                            _createElementVNode("div", _hoisted_7, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (lang, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: lang }, [
                                        _createElementVNode("button", {
                                            onClick: ($event) => (_unref(setLanguage)(lang)),
                                            class: _normalizeClass([
                                                'hover:text-accent transition-colors',
                                                _unref(language) === lang
                                                    ? 'text-accent underline decoration-2 underline-offset-4'
                                                    : 'opacity-40',
                                            ])
                                        }, _toDisplayString(lang), 11 /* TEXT, CLASS, PROPS */, _hoisted_8),
                                        (index < languages.length - 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "/"))
                                            : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */));
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-[1px] h-6 bg-black/10 dark:bg-white/10 hidden md:block" }, null, -1 /* CACHED */)),
                            _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('toggleTheme'))),
                                class: "p-2 hover:bg-black/5 dark:hover:bg-white/5 transition-colors duration-300 focus:outline-none rounded-none",
                                "aria-label": "Toggle Theme"
                            }, [
                                (__props.darkMode)
                                    ? (_openBlock(), _createBlock(_unref(Icon), {
                                        key: 0,
                                        icon: "ph:sun-bold",
                                        class: "w-5 h-5"
                                    }))
                                    : (_openBlock(), _createBlock(_unref(Icon), {
                                        key: 1,
                                        icon: "ph:moon-bold",
                                        class: "w-5 h-5"
                                    }))
                            ]),
                            _createCommentVNode(" Mobile Menu Button "),
                            _createElementVNode("button", {
                                onClick: _cache[1] || (_cache[1] = ($event) => (mobileMenuOpen.value = !mobileMenuOpen.value)),
                                class: "md:hidden p-2 hover:bg-black/5 dark:hover:bg-white/5 transition-colors duration-300 focus:outline-none rounded-none",
                                "aria-label": "Toggle Menu"
                            }, [
                                (mobileMenuOpen.value)
                                    ? (_openBlock(), _createBlock(_unref(Icon), {
                                        key: 0,
                                        icon: "ph:x-bold",
                                        class: "w-5 h-5"
                                    }))
                                    : (_openBlock(), _createBlock(_unref(Icon), {
                                        key: 1,
                                        icon: "ph:list-bold",
                                        class: "w-5 h-5"
                                    }))
                            ])
                        ])
                    ])
                ], 2 /* CLASS */),
                _createCommentVNode(" Mobile Menu Overlay "),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createVNode(_Transition, {
                        "enter-active-class": "transition-opacity duration-300 ease-out",
                        "leave-active-class": "transition-opacity duration-300 ease-in",
                        "enter-from-class": "opacity-0",
                        "leave-to-class": "opacity-0"
                    }, {
                        default: _withCtx(() => [
                            (mobileMenuOpen.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "fixed inset-0 z-50 bg-black/60 backdrop-blur-sm md:hidden",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (mobileMenuOpen.value = false))
                                }))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_Transition, {
                        "enter-active-class": "transition-transform duration-300 ease-out",
                        "leave-active-class": "transition-transform duration-300 ease-in",
                        "enter-from-class": "-translate-y-full",
                        "leave-to-class": "-translate-y-full"
                    }, {
                        default: _withCtx(() => [
                            (mobileMenuOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createCommentVNode(" Mobile Menu Header "),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("a", {
                                            href: "#",
                                            class: "flex items-center gap-2",
                                            onClick: _cache[3] || (_cache[3] = ($event) => (mobileMenuOpen.value = false))
                                        }, [
                                            _createElementVNode("img", {
                                                src: __props.darkMode ? _unref(logoDark) : _unref(logoLight),
                                                alt: `${_unref(PORTFOLIO_OWNER)} logo`,
                                                class: "w-9 h-9 object-contain"
                                            }, null, 8 /* PROPS */, _hoisted_12)
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[4] || (_cache[4] = ($event) => (mobileMenuOpen.value = false)),
                                            class: "p-2 hover:bg-black/5 dark:hover:bg-white/5 transition-colors duration-300 focus:outline-none rounded-none",
                                            "aria-label": "Close Menu"
                                        }, [
                                            _createVNode(_unref(Icon), {
                                                icon: "ph:x-bold",
                                                class: "w-6 h-6"
                                            })
                                        ])
                                    ]),
                                    _createElementVNode("nav", _hoisted_13, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navLinks.value, (link) => {
                                            return (_openBlock(), _createElementBlock("a", {
                                                key: link.href,
                                                href: link.href,
                                                onClick: _cache[5] || (_cache[5] = ($event) => (mobileMenuOpen.value = false)),
                                                class: "text-3xl font-bold uppercase tracking-wider hover:text-accent transition-colors duration-300 py-2"
                                            }, _toDisplayString(link.name), 9 /* TEXT, PROPS */, _hoisted_14));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _createCommentVNode(" Mobile Language Switcher at bottom "),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (lang, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: lang }, [
                                                    _createElementVNode("button", {
                                                        onClick: ($event) => (_unref(setLanguage)(lang)),
                                                        class: _normalizeClass([
                                                            'hover:text-accent transition-colors py-1',
                                                            _unref(language) === lang
                                                                ? 'text-accent underline decoration-2 underline-offset-4'
                                                                : 'opacity-40',
                                                        ])
                                                    }, _toDisplayString(lang), 11 /* TEXT, CLASS, PROPS */, _hoisted_17),
                                                    (index < languages.length - 1)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "/"))
                                                        : _createCommentVNode("v-if", true)
                                                ], 64 /* STABLE_FRAGMENT */));
                                            }), 64 /* STABLE_FRAGMENT */))
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
